import React, { Component } from "react";
import Search from "../../../../common/components/search-text/search-text";
import Button from "../../../button-classic/button-classic";
import { connect } from "react-redux";
import ACTIONS from "../../../../common/action_constant";
import Delete from "../../../../assets/images/delete.svg";
import Edit from "../../../../assets/images/edit.svg";
import { withRouter } from "react-router-dom";
import AddTransporterBypassMaster from "./add-transporter-bypass-master";
import { getItemFromSessionStorage } from "Utils/sessionStorage";
import { getEmail, getUserId } from "Utils/common";

class TransporterBypassMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      offset: 0,
      limit: 10,
      transporterBypassData: [],
      transporterOptions: [],
    };
  }

  componentDidMount() {
    this.getTransporterBypassList();
  }

  getTransporterBypassList = () => {
    const { dispatch, companyId } = this.props;
    const { search, offset, limit } = this.state;
    let param = `?companyId=${companyId}&limit=${limit}&offset=${offset}`;
    if (search) {
      param += `&search=${search}`;
    }
    dispatch({
      type: ACTIONS.PLANTS.GET_TRANSPORTER_BYPASS_LIST,
      param,
      onSuccess: (res) => {
        this.setState({ transporterBypassData: res || [] });
      },
    });
  };

  getTransporterOptions = () => {
    const { dispatch, companyId } = this.props;
    dispatch({
      type: ACTIONS.HOME.FETCH_SAP_VENDOR_PROVIDERS,
      queryParams: { companyId, limit: 1000, offset: 0 },
      onSuccess: (data) => {
        const list = (data && data.list) || [];
        const transporterOptions = list.map((item) => ({
          value: item.id,
          label: item.company_name,
          transporter_id: item.id,
          transporter_name: item.company_name,
          email: item.email,
          pan_no: item.pan_no,
        }));
        this.setState({ transporterOptions });
      },
    });
  };

  changeHandler = (value) => {
    this.setState({ search: value });
  };

  toggleAdd = () => {
    const { isOpen } = this.state;
    const willOpen = !isOpen;
    this.setState({ isOpen: willOpen, editData: "" });
    if (willOpen) {
      this.getTransporterOptions();
    }
  };

  onSaveTransporterBypass = (data) => {
    const { dispatch } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.ADD_TRANSPORTER_BYPASS,
      data,
      onSuccess: () => {
        this.setState({ isOpen: false }, this.getTransporterBypassList);
      },
    });
  };

  onUpdateTransporterBypass = (data) => {
    const previousData = getItemFromSessionStorage("previousTransporterBypassData");
    previousData["update_flag"] = true;
    previousData["user_email"] = getEmail();
    previousData["user_id"] = getUserId();
    const { dispatch } = this.props;
    const payload = {
      ...data,
      previous_data: previousData,
    };
    dispatch({
      type: ACTIONS.PLANTS.UPDATE_TRANSPORTER_BYPASS,
      data: payload,
      onSuccess: () => {
        this.setState({ isOpen: false, editData: "" }, this.getTransporterBypassList);
      },
    });
  };

  onSearch = () => {
    this.setState({ offset: 0 }, this.getTransporterBypassList);
  };

  editTransporterBypass = (data) => {
    const meta = this.getTransporterMeta(data.transporter_id);
    this.setState({
      editData: {
        ...data,
        email: data.email || meta.email,
        pan_no: data.pan_no || meta.pan_no,
      },
      isOpen: true,
    });
    this.getTransporterOptions();
  };

  deleteTransporterBypass = (data) => {
    const { dispatch, companyId } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.DELETE_TRANSPORTER_BYPASS,
      data: {
        company_id: companyId,
        transporter_id: data.transporter_id,
      },
      onSuccess: () => {
        this.getTransporterBypassList();
      },
    });
  };

  previous = () => {
    if (this.state.offset >= this.state.limit) {
      this.setState(
        (prevState) => ({
          offset: prevState.offset - prevState.limit,
        }),
        this.getTransporterBypassList
      );
    }
  };

  next = () => {
    this.setState(
      (prevState) => ({
        offset: prevState.offset + prevState.limit,
      }),
      this.getTransporterBypassList
    );
  };

  clearFilterOnCancel = () => {
    this.setState({ search: "", offset: 0 }, this.getTransporterBypassList);
  };

  handleOnClickForAuditBtn = () => {
    const { history, companyId } = this.props;
    const masterType = 65;
    const navUrl = `/auditScreen/${companyId}/${masterType}`;
    history.push(navUrl);
  };

  getTransporterMeta = (transporterId) => {
    const { transporterOptions } = this.state;
    return (
      (transporterOptions || []).find(
        (option) => option.transporter_id == transporterId
      ) || {}
    );
  };

  render() {
    const { transporterBypassData, transporterOptions } = this.state;
    return (
      <div className={"location-network"}>
        <div>
          <div style={{ display: "block", paddingBottom: "15px" }}>
            <Search
              id="search"
              value={this.state.search}
              placeholder="Search..."
              changeHandler={this.changeHandler}
              click={this.onSearch}
              canClear={this.state.search !== ""}
              handleClearFilter={this.clearFilterOnCancel}
            />
            <Button
              value={"+ Add Transporter"}
              click={this.toggleAdd}
            />
            <button
              className="button-classic"
              onClick={this.handleOnClickForAuditBtn}
            >
              Audit
            </button>
          </div>
        </div>
        <table className="custom-sap-table">
          <thead>
            <tr>
              <th>Transporter Name</th>
              <th>Consignee Review Skip</th>
              <th>Email</th>
              <th>PAN</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {(transporterBypassData || []).map((item, index) => {
              return (
              <tr key={`transporter_bypass_${index}`}>
                <td>{item.transporter_name}</td>
                <td>{item.is_consignee_review_skip ? "Yes" : "No"}</td>
                <td>{item.provider_email || "-"}</td>
                <td>{item.pan_no || "-"}</td>
                <td>
                  <div
                    className="action-icon"
                    style={{ backgroundImage: `url(${Edit})` }}
                    onClick={() => this.editTransporterBypass(item)}
                  />
                  <div
                    className="action-icon"
                    style={{ backgroundImage: `url(${Delete})` }}
                    onClick={() => this.deleteTransporterBypass(item)}
                  />
                </td>
              </tr>
              );
            })}
          </tbody>
        </table>

        <div className="submit-section-pagination">
          <div className="next">
            <Button value="Next" click={this.next} />
          </div>
          <div className="pre">
            <Button value="Previous" click={this.previous} />
          </div>
        </div>
        {this.state.isOpen && (
          <AddTransporterBypassMaster
            toggleAdd={this.toggleAdd}
            onSave={this.onSaveTransporterBypass}
            onUpdate={this.onUpdateTransporterBypass}
            companyId={this.props.companyId}
            editData={this.state.editData}
            transporterOptions={transporterOptions}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(withRouter(TransporterBypassMaster));
